import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { useTranslation } from 'react-i18next'
import { defaultCurrency, type DisplayCurrency } from '../lib/pricing'

// Explicit currency choice from the pricing picker. When the visitor hasn't
// picked, display currency follows the UI language (see useDisplayCurrency).
// This is display only — Iyzico always charges the fixed TRY amount.
interface CurrencyState {
  currency: DisplayCurrency
  userPicked: boolean
  setCurrency: (c: DisplayCurrency) => void
}

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set) => ({
      currency: defaultCurrency(),
      userPicked: false,
      setCurrency: (c) => set({ currency: c, userPicked: true }),
    }),
    { name: 'oaas_currency' },
  ),
)

// Active display currency for components. If the user explicitly picked one it
// wins and stays stable across language changes; otherwise it follows the UI
// language (tr → TRY, de/fr/es → EUR, else USD). Reads useTranslation so it
// re-renders when the language switches.
export function useDisplayCurrency(): DisplayCurrency {
  const { i18n } = useTranslation()
  const currency = useCurrencyStore((s) => s.currency)
  const userPicked = useCurrencyStore((s) => s.userPicked)
  return userPicked ? currency : defaultCurrency(i18n.language)
}
